import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploader } from 'ng2-file-upload';
import { FormsModule } from '@angular/forms';
import { APP_CONTS } from '../../../app.constants';
import { ImageResizeService } from '../../../services/image-resize.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { GeneralService } from '../../../services/general/general.service';
import { CategoriaService } from '../../../services/categoria/categoria.service';
import { Categoria } from '../../../../model/class/Categoria';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-categorias',
  templateUrl: './edit-categorias.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./edit-categorias.component.css']
})
export class EditCategoriasComponent implements OnInit {

  @Input() newCategoria: Categoria;
  @Input() nivel: number;
  @Input() padre: Categoria;
  editando = false;
  titulo = 'Nueva Categoría';

  loaders = {
    image: false,
    form: false
  };

  imageFormat = APP_CONTS.FILES.IMAGE_FORMAT_STR;

  public uploader: FileUploader = new FileUploader({
    allowedMimeType:  APP_CONTS.FILES.IMAGE_FORMAT
  });

  constructor(
    private _generalService: GeneralService,
    public activeModal: NgbActiveModal,
    private imageResizeService: ImageResizeService,
    private categoriaService: CategoriaService,
    private toasts: ToastsManager,
  ) {
  }

  ngOnInit() {
    if (this.newCategoria.id) {
      this.editando = true;
      this.titulo = 'Editar';
    } else {
      this.newCategoria.publicada = 1;
    }

    this.titulo = this.titulo + ` (Nivel ${this.nivel})`;
  }

  asigneImage(event: any) {
    if (this.uploader.queue[this.uploader.queue.length - 1]) {
      const file = this.uploader.queue[this.uploader.queue.length - 1]._file;
      if (file) {
        this.loaders.image = true;
        this.newCategoria.nuevaImagen = file;
        this.imageResizeService.resize([file], 500, 200)
          .subscribe((result) => {
            this.loaders.image = false;
            const reader = new FileReader();
            reader.onload = (e: any) => {
              this.newCategoria.imagen = e.target.result;
            };
            reader.readAsDataURL(result);
          });
      }
    } else {
      console.log('Archivo no valido');
    }
  }

  onSubmit() {
    if (this.padre) {
      this.newCategoria.categoriaId = this.padre.id;
    }

    const tempCat = new Categoria(this.newCategoria);
    let accion: string;
    let promise: any;

    if (this.editando) {
      promise = this.categoriaService.edit(this.newCategoria.id, tempCat.getFormData());
      accion = 'modificada';
    } else {
      promise = this.categoriaService.create(tempCat.getFormData());
      accion = 'creada';
    }

    this.loaders.form = true;
    forkJoin([promise])
      .subscribe(
        (data: any) => {
          this.loaders.form = false;
          this.toasts.success(`La Categoria a sido ${accion} exitosamente.`);
          this._generalService.revalidarPathCache('category').subscribe();
          this.activeModal.close(data[0].data);
        }, (error) => {
          this.loaders.form = false;
          this.toasts.error(`Ha ocurrido un error al ejecutar la acción `);
        }
      );


  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/edit-categorias/edit-categorias.component.ts